<template>
  <div class="mit-no-access-page mit-page">
      <v-container>
      <v-row>
        <v-col cols="12" class="d-flex justify-left">
          <div class="pa-2">
            <h3 class="pb-2">No Access</h3>
            <p>You do not have permission to access this page.</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitNoAccessPage'
  }
</script>

<style lang="scss" scoped>
</style>
